(ns frontend.ui.component.lp-portal.content.pdf.view)

(defn content
  "PDFMake `:content`.

  Ensures each page but the last holds a `:pageBreak` effectively making it a page. Watch-out, this
  means values for key `:content` must be maps."
  [content-specs]
  (let [pages-butlast (butlast content-specs)
        last-spec (last content-specs)]
    (concat (->> pages-butlast
                 (map (fn [page]
                        (if (:pageBreak page)
                          page
                          (assoc page :pageBreak :after)))))
            (concat [last-spec]))))
